import React from 'react';

/**
 * Modern Card Component with new design system
 */
const Card = ({ 
  children, 
  className = '',
  hover = false,
  onClick = null,
  ...props 
}) => {
  const baseStyles = 'bg-white rounded-xl border border-slate-100 shadow-soft';
  const hoverStyles = hover ? 'hover:shadow-soft-xl hover:-translate-y-1 transition-all duration-300 cursor-pointer' : '';
  const clickableStyles = onClick ? 'cursor-pointer' : '';

  return (
    <div 
      className={`${baseStyles} ${hoverStyles} ${clickableStyles} ${className}`}
      onClick={onClick}
      {...props}
    >
      {children}
    </div>
  );
};

export default Card;

